import { Link } from "react-router-dom";

export default function Footer1() {
    return (
        <>
        <footer className="footer-1">
            <div className="footer-1-top">
                <div className="auto-container">
                    <div className="footer-1-top-content d-flex align-items-center justify-content-between">
                        <div className="logo"><Link href="/"><img src="assets/images/newnewLogo.png" alt="" /></Link></div>
                        <ul className="footer-1-social-icon d-flex align-items-center">
                            <li><Link href="/"><i className="fab fa-facebook-f"></i></Link></li>
                            <li><Link href="/"><i className="fab fa-twitter"></i></Link></li>
                            <li><Link href="/"><i className="fab fa-linkedin-in"></i></Link></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="footer-1-middle">
                <div className="auto-container">
                    <div className="row">
                        <div className="col-lg-3 col-md-6">
                            <div className="about-widget-1">
                                <div className="footer-widget-title"><h4>About</h4></div>
                                <div className="about-widget-1-text">
                                    <p>We acknowledge the traditional owners of the lands on which we live and <br />
                                    work. we pay our respects to elders past, present and emerging. we are <br /> committed to honouring indigenous peoples’ unique cultural and spiritual <br /> relationships to the land, waters and seas and their rich contribution to society. We support community and their equality.</p>
                                    <img src="assets/images/shape/flags.jpeg" alt="flags" width={150} />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="link-widget-1 px-lg-5">
                                <div className="footer-widget-title"><h4></h4></div>
                                
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="link-widget-1">
                                <div className="footer-widget-title"><h4>Quick Link</h4></div>
                                <ul className="link-widget-1-list">
                                    <li><a href="#about">About Us</a></li>
                                    <li><Link href="/service">Services</Link></li>
                                    <li><a href="#contact">Contact Us</a></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="contact-widget-1">
                                <div className="footer-widget-title"><h4>Contact Us</h4></div>
                                <div className="contact-widget-text">Sha Care</div>
                                <ul className="contact-widget-1-list">
                                    <li><i className="icon-14"></i> Western Australia,  South and North Perth. Perth metro.</li>
                                    <li><i className="icon-3"></i><Link href="mailto:example@lovegiver.com">info@shacaresupport.com.au</Link></li>
                                    <li><i className="icon-2"></i><Link href="tel:0451235724">0451235724</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer-bottom">
                <div className="auto-container">    
                    <div className="footer-bottom-row">
                        <div className="footer-bottom-text">Copyright 2025 by MyLkSystems. All Right Reserved.</div>
                    </div>
                </div>
            </div>
        </footer>

        </>
    )
}
